import { apiRequest } from "../util/apiUtils";

export const questionList = async (params) => {
  try {
    const res = await apiRequest("get", `question/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const questionAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `question/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const questionDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `question/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const questionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `question/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
